import {NgModule} from '@angular/core';
import {TabsModule} from '../../modules/@tabs/tabs.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {DataTableModule} from '../../modules/@datatable/datatables.module';
import {SharedModule} from '../../shared/shared.module';
import {PreloaderModule} from '../../modules/@preloader/preloader.module';
import {SimpleTableModule} from '../../modules/@simple-table/simple-table.module';
import {MaterialInputModule} from '../../modules/@material-input/material-input.module';
import {ReferenceComponent} from './reference.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DataTableModule,
    TabsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialInputModule,
    SharedModule,
    PreloaderModule,
    SimpleTableModule,
  ],
  declarations: [
    ReferenceComponent
  ]
})
export class ReferenceModule {

}
